<template>
  <canvas class="mx-auto" :class="size" />
</template>

<script>
import qrcode from "qrcode";
export default {
  props: {
    text: {
      type: String,
    },
    size: {
      type: Number,
      default: 200,
    },
    light: {
      type: String,
      default: "#ffffffff",
    },
    dark: {
      type: String,
      default: "#000000ff",
    },
    version: {
      type: [Number, Boolean, String],
      default: 7,
    },
  },
  mounted() {
    qrcode.toCanvas(
      this.$el,
      this.text,

      {
        color: {
          light: this.light,
          dark: this.dark,
        },
        margin: 1,
        version: this.version,
        width: this.size,
        scale: 4,
        quality: 0.3,
      },
      function (error) {
        if (error) console.error(error);
      }
    );
  },
};
</script>

<style lang="scss" scoped></style>
